import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import { setupCalendar, Calendar, DatePicker } from 'v-calendar'
import 'v-calendar/dist/style.css'
import VueClipboard from 'vue3-clipboard'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as defines from '@/defines'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.use(setupCalendar)
app.component('Calendar', Calendar)
app.component('DatePicker', DatePicker)
app.use(VueClipboard, { autoSetContainer: true, appendToBody: true })
app.use(ElementPlus)
app.config.globalProperties.$defines = defines
app.mount('#app')
